import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  isLoading?: boolean;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "md",
  isLoading = false,
  children,
  className = "",
  disabled,
  icon,
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed space-x-2";

  const variants = {
    primary:
      "bg-[#C97A3C] hover:bg-[#B86B30] text-white focus:ring-[#C97A3C] shadow-sm hover:shadow-md",
    secondary:
      "bg-[#0B0F0E] hover:bg-[#1a1e1c] text-white focus:ring-[#0B0F0E] shadow-sm hover:shadow-md",
    outline:
      "border border-[rgba(11,15,14,0.15)] bg-white hover:bg-[#F5F4F0] text-[#0B0F0E] focus:ring-[#C97A3C] shadow-sm",
    ghost: "text-[#0B0F0E] hover:bg-[#F5F4F0] focus:ring-[#C97A3C]",
    danger:
      "bg-[#E24B4A] hover:bg-red-700 text-white focus:ring-[#E24B4A] shadow-sm hover:shadow-md",
  };

  const sizes = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  return (
    <button className={classes} disabled={disabled || isLoading} {...props}>
      {isLoading ? (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
      ) : icon ? (
        <span className="mr-2">{icon}</span>
      ) : null}
      {children}
    </button>
  );
};

export default Button;
